import type {App} from "crqlar-react-common/dist/models/app/app.model";
import type {OrganizationApp} from "crqlar-react-common/dist/models/app/organizationApp.model";
import type {CrossSaleOpportunityApp} from "crqlar-react-common/dist/models/app/crossSaleOpportunityApps";
import type {Sector} from "crqlar-react-common/dist/models/sector/sector.model";

/*
    Mirrors CrossSaleServiceV3.isSubscribed on the API, which re-checks every lead server-side.
    Only decides what the UI shows — it grants nothing.
 */

export const findCrossSaleMarketplaceApp = (
    opportunity: CrossSaleOpportunityApp,
    marketplaceApps: App[],
) => marketplaceApps.find(app => (
    app.sku === opportunity.sku
    && (!opportunity.specialization || app.specialization === opportunity.specialization)
));

/*
    `reservations` flavours are identified by the type of the sector the installation is configured with
    (some installations point at the Spa marketplace app whatever their sector is); installations without a
    resolvable sector, and every other app, by the marketplace app they point at.
 */
export const isCrossSaleInstallation = (
    opportunity: CrossSaleOpportunityApp,
    orgApp: OrganizationApp,
    marketplaceApps: App[],
    sectors: Sector[],
) => {
    const sectorId = orgApp.configuration?.sectorId;
    const sectorType = sectorId ? sectors.find(sector => sector.id === sectorId)?.sectorType : undefined;

    if (opportunity.sectorType && sectorType) {
        return sectorType === opportunity.sectorType;
    }

    return !!orgApp.appId && marketplaceApps.some(app => (
        app.id === orgApp.appId
        && app.sku === opportunity.sku
        && (!opportunity.specialization || app.specialization === opportunity.specialization)
    ));
};

export const isCrossSaleAppSubscribed = (
    opportunity: CrossSaleOpportunityApp,
    organizationApps: OrganizationApp[],
    marketplaceApps: App[],
    sectors: Sector[],
) => organizationApps.some(orgApp => isCrossSaleInstallation(opportunity, orgApp, marketplaceApps, sectors));
